<script lang="ts">
	import { Input, type InputProps } from "flowbite-svelte-v1";
	import { browser } from "$app/env";

	interface Props {
		id?: string;
		value?: string | undefined;
		disabled?: boolean;
		required?: boolean;
		color?: InputProps["color"];
		class?: string;
		onBlur?: (e: FocusEvent) => void;
		onInput?: (e: Event) => void;
		onChange?: (newValue: string | undefined) => void;
	}

	let { id, value, disabled = false, required = false, color = "default", class: className = "", onBlur, onInput, onChange }: Props = $props();

	let hiddenInput: HTMLInputElement | undefined = $state();
	let year = $state(value ? new Date(value).getUTCFullYear().toString() : "");
	let month = $state(value ? formatTwoDigits(new Date(value).getUTCMonth() + 1) : "");
	let day = $state(value ? formatTwoDigits(new Date(value).getUTCDate()) : "");

	$effect(() => {
		if (!value) {
			year = "";
			month = "";
			day = "";
		}
	});

	function handleChange() {
		const y = Number.parseInt(year, 10);
		const m = Number.parseInt(month, 10);
		const d = Number.parseInt(day, 10);
		const newDate = new Date(y, m, d);
		value = newDate ? `${y}-${formatTwoDigits(m)}-${formatTwoDigits(d)}` : undefined;
		if (hiddenInput) {
			hiddenInput.value = value ?? "";
			hiddenInput.dispatchEvent(new Event("change"));
		}
		onChange?.(value);
	}

	function handleInput(e: Event) {
		onInput?.(e);
	}

	function handleBlur(e: FocusEvent) {
		year = formatTwoDigits(Number.parseInt(year, 10));
		month = formatTwoDigits(Number.parseInt(month, 10));
		day = formatTwoDigits(Number.parseInt(day, 10));
		if (!Number.isNaN(Number.parseInt(year, 10)) && !Number.isNaN(Number.parseInt(month, 10)) && !Number.isNaN(Number.parseInt(day, 10))) {
			onBlur?.(e);
		}
	}

	function formatTwoDigits(num: number): string {
		return num < 10 ? `0${num}` : `${num}`;
	}
</script>

<div class="grid grid-cols-3 gap-3">
	<!-- We have to use the old style event handler here because dispatchEvent doesn't seem to fire onchange-->
	<!-- svelte-ignore event_directive_deprecated -->
	<input {id} bind:this={hiddenInput} type="hidden" {value} on:change={handleInput} />
	{#if !browser || navigator.language.startsWith("en")}
		<Input id="{id}-month" type="number" bind:value={month} class={className} {color} {disabled} {required} placeholder="MM" min="1" max="12" aria-label="Month" onblur={handleBlur} onchange={handleChange} />
		<Input id="{id}-day" type="number" bind:value={day} class={className} {color} {disabled} {required} placeholder="DD" min="1" max="31" aria-label="Day" onblur={handleBlur} onchange={handleChange} />
	{:else}
		<Input id="{id}-day" type="number" bind:value={day} class={className} {color} {disabled} {required} placeholder="DD" min="1" max="31" aria-label="Day" onblur={handleBlur} onchange={handleChange} />
		<Input id="{id}-month" type="number" bind:value={month} class={className} {color} {disabled} {required} placeholder="MM" min="1" max="12" aria-label="Month" onblur={handleBlur} onchange={handleChange} />
	{/if}
	<Input id="{id}-year" type="number" bind:value={year} class={className} {color} {disabled} {required} placeholder="YYYY" min="1900" max="2100" aria-label="Year" onblur={handleBlur} onchange={handleChange} />
</div>
